<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Linktiles } from '#library/components.schema.build.ts'
	import Link from '#components/link.svelte'

	interface Props {
		blok: Blok<Linktiles>
	}

	let { blok }: Props = $props()
	const items = $derived(blok.items ?? [])
</script>

<section class="linktiles {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		<svelte:element this={blok.title?.tag || 'div'} class="title">{blok.title?.text}</svelte:element>
		{#if items?.length}
			<div class="items">
				{#each items as { link, subtitle, _uid } (_uid)}
					{#if link?.text}
						<Link href={link.url} text={link.text ?? ''} target={link.target} {subtitle} small />
					{/if}
				{/each}
			</div>
		{/if}
	</div>
</section>

<style lang="css">
	.linktiles {
		background-color: var(--c-background);
		color: var(--c-foreground);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.contain {
		display: grid;
		gap: 1rem;

		@media (--from-mobile) {
			grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
		}
	}

	.title {
		font: 600 var(--f-h2);
		letter-spacing: var(--ls-h2);
	}

	.items {
		display: grid;
		gap: 2rem;

		@media (--from-mobile) {
			gap: 4rem 2.5rem;
			grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
		}
	}
</style>
